export default "__VITE_ASSET__DF0L65rG__"